import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlSignature } from '../common/apiEndPoint';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface SignupOtpData {
  otpCode: string;
}

export interface ResendOtpData {
  email: string;
}

export interface SignupOtpResponse {
  success: boolean;
  message: string;
  email?: string;
  userId?: string;
}

export interface ResendOtpResponse {
  success: boolean;
  message: string;
  email: string;
  expiresAt?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OtppageService {
  private signupOtpVerificationUrl: string;
  private resendOtpUrl: string;

  constructor(private http: HttpClient, private urlSignature: UrlSignature) {
    this.signupOtpVerificationUrl = this.urlSignature.paymentsignupverificationUrl;
    this.resendOtpUrl = this.urlSignature.paymentsignupotpresendUrl;
  }

  submitSignup(otpData: SignupOtpData): Observable<SignupOtpResponse> {
    return this.http.post<SignupOtpResponse>(this.signupOtpVerificationUrl, otpData).pipe(
      catchError((error) => {
        console.error('Error occurred during OTP submission:', error);
        return throwError(() => error);
      })
    );
  }

  resendOtp(resendData: ResendOtpData): Observable<ResendOtpResponse> {
    return this.http.post<ResendOtpResponse>(this.resendOtpUrl, resendData).pipe(
      catchError((error) => {
        console.error('Error occurred during OTP resend:', error);
        return throwError(() => error);
      })
    );
  }

  resendOtpByUserId(userId: string): Observable<ResendOtpResponse> {
    const payload = { userId };
    return this.http.post<ResendOtpResponse>(this.resendOtpUrl, payload).pipe(
      catchError((error) => {
        console.error('Error occurred during OTP resend by user ID:', error);
        return throwError(() => error);
      })
    );
  }
}
